"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowLeftIcon = void 0;
/* eslint-disable max-len */
var react_1 = __importStar(require("react"));
var Icon_1 = require("./Icon");
exports.ArrowLeftIcon = (0, react_1.forwardRef)(function ArrowLeftIcon(props, ref) {
    return (react_1.default.createElement(Icon_1.Icon, __assign({ ref: ref, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.5928 7.53911C10.6942 7.43776 10.7746 7.31743 10.8294 7.185C10.8843 7.05257 10.9125 6.91064 10.9125 6.7673C10.9125 6.62396 10.8843 6.48202 10.8294 6.34959C10.7746 6.21716 10.6942 6.09684 10.5928 5.99548C10.4915 5.89412 10.3711 5.81372 10.2387 5.75887C10.1063 5.70401 9.96435 5.67578 9.82101 5.67578C9.53152 5.67578 9.25389 5.79078 9.04919 5.99548L3.81501 11.2308C3.6105 11.4353 3.49561 11.7128 3.49561 12.002C3.49561 12.2913 3.6105 12.5687 3.81501 12.7733L9.04919 18.0075C9.25389 18.2122 9.53152 18.3272 9.82101 18.3272C10.1105 18.3272 10.3881 18.2122 10.5928 18.0075C10.7975 17.8028 10.9125 17.5251 10.9125 17.2357C10.9125 16.9462 10.7975 16.6685 10.5928 16.4638L9.05137 14.9235C8.47116 14.3439 7.82746 13.8316 7.13246 13.3962L6.31755 12.8835L6.36883 12.8333L7.41501 12.9828C7.92596 13.0556 8.44144 13.092 8.95755 13.0918H19.6365C19.9258 13.0918 20.2033 12.9769 20.4079 12.7723C20.6124 12.5677 20.7274 12.2903 20.7274 12.0009C20.7274 11.7116 20.6124 11.4341 20.4079 11.2295C20.2033 11.025 19.9258 10.91 19.6365 10.91H8.95646C8.44032 10.9102 7.92485 10.947 7.41392 11.0202L6.36664 11.1697L6.31646 11.1184L7.13464 10.6057C7.82846 10.1705 8.47105 9.6585 9.05028 9.07948L10.5928 7.53911Z", fill: "currentColor" })));
});
